import React, { useState, Component } from "react";
import Paper from "@material-ui/core/Paper";
import {
  TreeDataState,
  CustomTreeData,
  SearchState,
  IntegratedFiltering,
  SortingState,
  IntegratedSorting,
  FilteringState
} from "@devexpress/dx-react-grid";
import {
  Grid,
  Table,
  TableHeaderRow,
  TableTreeColumn,
  TableColumnVisibility,
  Toolbar,
  ColumnChooser,
  SearchPanel,
  VirtualTable,
  TableFilterRow
} from "@devexpress/dx-react-grid-material-ui";
import metaData from "../metaData";
import loader from "../images/loader.gif";
import axios from "axios";
import { CSVLink, CSVDownload } from "react-csv";
import _ from "lodash";
import moment from "moment";
import { array } from "prop-types";
let addDates = metaData[0].addDates;

let agencyDataParams = metaData[0].agency_data.params;
let spacekey;
let workOrderObj = localStorage.getItem("workOrderObj");
workOrderObj = JSON.parse(workOrderObj);
if (workOrderObj) {
  spacekey = workOrderObj.hierarchy[workOrderObj.hierarchy.length - 2];
}
let th;
export default class Agency extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: "",
      selectedProject: metaData[0],
      agencyDataObject: [],
      WorkOrderClients: [],
      ulbLevel: "",
      ulbNameArray: [],
      loading: true,
      notGettingData: "",
      showdownloadAgentSummeryData: false,
      allAgencyDataObject: [],
      headers: [
        { label: "Agency", key: "agency" },
        { label: "Agent Name", key: "agentName" },
        { label: "Buildings", key: "buildings" },
        { label: "Dwellings", key: "dwellings" },
        { label: "Ulb", key: "ulb" }
      ]
    };
    this.agencyDataCalling = this.agencyDataCalling.bind(this);
    this.callDidMountMultipleTimes = this.callDidMountMultipleTimes.bind(this);
    this.toggleDownloadDropdown = this.toggleDownloadDropdown.bind(this);
    //this.addDates=this.addDates.bind(this);
    th = this;
  }

  agencyDataCalling(agencyDataParams) {
    agencyDataParams.spaceKey = spacekey;
    agencyDataParams.userKey = "agent";
    axios
      .get(this.state.selectedProject.agency_data.url, {
        params: agencyDataParams,
        headers: this.state.selectedProject.headers
      })
      .then(res => {
        if (res.data.response.analyticsDocs.length < 0) {
          this.setState({
            loading: false,
            notGettingData: "No Data"
          });
        } else {
          this.setState({
            loading: false
          });
        }
        let response = res.data.response.analyticsDocs;
        let agencyDataObjectArray = [];
        response.map(ele => {
          let agencyDataObject = {};
          agencyDataObject.agentName = ele.user
            ? ele.user.extraInfo.first_name
            : "";
          agencyDataObject.agency = ele.user
            ? ele.user.extraInfo.clientName
            : "";
          agencyDataObject.ulb = ele.space.name;
          agencyDataObject.zp_type = ele.zp_type;
          agencyDataObject.buildings = ele.count.ddn;
          agencyDataObjectArray.push(agencyDataObject);
        });

        let buildingArray = [];
        let dwellingArray = [];
        agencyDataObjectArray.map(ele => {
          if (ele.zp_type == 7) {
            buildingArray.push(ele);
          } else {
            dwellingArray.push(ele);
          }
        });
        buildingArray.map(ele => {
          ele.dwellings = 0;
          dwellingArray.map(dwelling => {
            if (ele.agentName == dwelling.agentName) {
              ele.dwellings = dwelling.buildings;
            }
          });
        });
        //agencyDataObjectArray =array;

        this.setState({
          agencyDataObject: buildingArray
        });
      });
  }

  componentDidMount() {
    let allApis = localStorage.getItem("allApis");
    if (allApis) {
      allApis = JSON.parse(allApis);
    }
    allApis.agency_data.params.spaceValue = "";
    agencyDataParams = allApis.agency_data.params;
    agencyDataParams.timeKey = "lifetime";

    this.agencyDataCalling(agencyDataParams);
    axios
      .get(this.state.selectedProject.workOrderClients.url, {
        params: this.state.selectedProject.workOrderClients.params,
        headers: this.state.selectedProject.headers
      })
      .then(res => {
        let workOrderClientsData = res.data.response.clientObjs;
        let clientObjectAyyay = [];
        workOrderClientsData.map(client => {
          let clientObject = {
            name: client.app_name,
            id: client._id
          };
          clientObjectAyyay.push(clientObject);
        });
        this.setState({
          WorkOrderClients: clientObjectAyyay
        });
      });

    axios
      .get(this.state.selectedProject.workOrder.url, {
        params: this.state.selectedProject.workOrder.params,
        headers: this.state.selectedProject.headers
      })
      .then(res => {
        let hierarchy = res.data.response.workOrderObj.hierarchy;
        let ulbLevel = hierarchy[hierarchy.length - 2];
        this.setState({
          ulbLevel: ulbLevel
        });
      });

    axios
      .get(this.state.selectedProject.ulb_treeDtata.url, {
        params: this.state.selectedProject.ulb_treeDtata.params,
        headers: this.state.selectedProject.headers
      })
      .then(res => {
        if (res.data.response) {
          let response = res.data.response.analyticsDocs;
          let dataArray = [];
          response.map(ele => {
            let spaceKey = ele.space.key;
            if (spaceKey == this.state.ulbLevel) {
              let dataObj = {
                name: ele.space.name,
                spaceValue: ele.space.value
              };
              dataArray.push(dataObj);
            }
          });
          dataArray = _.uniqBy(dataArray, "name");
          this.setState({
            ulbNameArray: dataArray
          });
        }
      });

    // this.timer = setInterval(() => {
    //   th.callDidMountMultipleTimes();
    // }, 10000)
  }

  componentWillUnmount() {
    // clearInterval(this.timer);
    // this.timer = null;
  }

  callDidMountMultipleTimes() {
    this.agencyDataCalling(agencyDataParams);
  }

  //  addDates(query){
  //   var formatStr = 'YYYY-MM-DD';
  //     var today = moment().subtract(1, 'days').format(formatStr);
  //     switch(query.timeKey) {
  //         case 'today':
  //             query.fromDate = today;
  //             query.timeKey = 'today';
  //             break;
  //         case 'yesterday':
  //             query.fromDate = moment().subtract(2, 'days').format(formatStr);
  //             query.toDate = today;
  //             query.timeKey = 'today';
  //             break;
  //         case 'this_week':
  //             query.fromDate = moment().startOf('week').format(formatStr);
  //             query.toDate = moment().format(formatStr);
  //             query.timeKey = 'today';
  //             break;
  //         case 'last_week':
  //             query.fromDate = moment().startOf('week').subtract(7, 'days').format(formatStr);
  //             query.toDate = moment().startOf('week').subtract(1, 'days').format(formatStr);
  //             query.timeKey = 'today';
  //             break;
  //         case 'last_7':
  //             query.fromDate = moment().subtract(7, 'days').format(formatStr);
  //             query.toDate = moment().subtract(1, 'days').format(formatStr);
  //             query.timeKey = 'today';
  //             break;
  //         case 'last_14':
  //             query.fromDate = moment().subtract(14, 'days').format(formatStr);
  //             query.toDate = moment().subtract(1, 'days').format(formatStr);
  //             query.timeKey = 'today';
  //             break;
  //         case 'this_month':
  //             query.fromDate = moment().startOf('month').format(formatStr);
  //             query.timeKey = 'month';
  //             // if($scope.isLastNode) {
  //             //     query.toDate = moment().endOf('month').format(formatStr);
  //             // }
  //             break;
  //         case 'last_month':
  //             query.fromDate = moment().subtract(1, 'months').startOf('month').format(formatStr);
  //             query.toDate = moment().subtract(1, 'months').endOf('month').format(formatStr);
  //             query.timeKey = 'month';
  //             // if($scope.isLastNode) {
  //             //     query.toDate = moment().subtract(1, 'months').endOf('month').format(formatStr);
  //             // }
  //             break;
  //         case 'lifetime':
  //             query.timeKey = 'lifetime';
  //             break;
  //         default:
  //             query.fromDate = today;
  //             query.timeKey = 'today';
  //             // query.fromDate = moment($scope.fromDate).format(formatStr);
  //             // query.toDate = moment($scope.toDate).format(formatStr);

  //             // if(query.fromDate === query.toDate) {
  //             //     delete query.toDate;
  //             //     query.timeKey = 'today';
  //             // } else if(isAMonth(query)) {
  //             //     delete query.toDate;
  //             //     query.timeKey = 'month';
  //             // } else if(isDiffInMonths() && $scope.fromDate.getDate() === 1 && moment($scope.toDate).endOf('month').format(formatStr) === query.toDate){
  //             //     query.timeKey = 'month';
  //             // } else {
  //             //     query.timeKey = 'today';
  //             // }
  //             //query.fromDate = '2016-04-06';
  //             //query.timeKey = 'today';
  //     }
  // }

  ulbFilter(e) {
    let value = e.target.value;
    if (value == "all") {
      agencyDataParams.spaceValue = "";
    } else {
      agencyDataParams.spaceValue = value;
    }
    this.agencyDataCalling(agencyDataParams);
  }
  timeFilter(e) {
    let value = e.target.value;
    agencyDataParams.timeKey = value;
    addDates(agencyDataParams);
    if (e.target.value == "today" || e.target.value == "this_month") {
      agencyDataParams.toDate = "";
    }
    this.agencyDataCalling(agencyDataParams);
  }

  agencyFilter(e) {
    if (e.target.value == "all") {
      agencyDataParams.userKey = "agent";
      agencyDataParams.clientId = "";
    } else {
      agencyDataParams.userKey = "agent";
      agencyDataParams.clientId = e.target.value;
    }
    this.agencyDataCalling(agencyDataParams);
  }

  downloadAgentSummeryData(e) {
    this.setState({
      showdownloadAgentSummeryData: !this.state.showdownloadAgentSummeryData
    });

    let allApis = localStorage.getItem("allApis");
    if (allApis) {
      allApis = JSON.parse(allApis);
    }
    let agencyDataParams = allApis.agency_data.params;
    agencyDataParams.spaceKey = spacekey;
    agencyDataParams.userKey = "agent";
    axios
      .get(this.state.selectedProject.agency_data.url, {
        params: agencyDataParams,
        headers: this.state.selectedProject.headers
      })
      .then(res => {
        if (res.data.response.analyticsDocs.length < 0) {
          this.setState({
            loading: false,
            notGettingData: "No Data"
          });
        } else {
          this.setState({
            loading: false
          });
        }
        let response = res.data.response.analyticsDocs;
        let agencyDataObjectArray = [];
        response.map(ele => {
          let agencyDataObject = {};
          agencyDataObject.agentName = ele.user
            ? ele.user.extraInfo.first_name
            : "";
          agencyDataObject.agency = ele.user
            ? ele.user.extraInfo.clientName
            : "";
          agencyDataObject.ulb = ele.space.name;
          agencyDataObject.zp_type = ele.zp_type;
          agencyDataObject.buildings = ele.count.ddn;
          agencyDataObjectArray.push(agencyDataObject);
        });

        let buildingArray = [];
        let dwellingArray = [];
        agencyDataObjectArray.map(ele => {
          if (ele.zp_type == 7) {
            buildingArray.push(ele);
          } else {
            dwellingArray.push(ele);
          }
        });
        buildingArray.map(ele => {
          ele.dwellings = 0;
          dwellingArray.map(dwelling => {
            if (ele.agentName == dwelling.agentName) {
              ele.dwellings = dwelling.buildings;
            }
          });
        });
        //agencyDataObjectArray =array;

        this.setState({
          allAgencyDataObject: buildingArray
        });
      });
  }

  toggleDownloadDropdown(e) {
    this.setState({
      showdownloadAgentSummeryData: !this.state.showdownloadAgentSummeryData
    });
  }

  render() {
    console.log(
      this.state.agencyDataObject,
      "agencyDataObjectagencyDataObject"
    );
    let data2 = [
      {
        gender: "Female",
        name: "Sandra",
        city: "Las Vegas",
        car: "Audi A4",
        items: null
      },
      {
        gender: "Male",
        name: "Venu",
        city: "Amarica",
        car: "Swift",
        items: null
      },
      {
        gender: "Female",
        name: "Sandra",
        city: "Las Vegas",
        car: "Audi A4",
        items: null
      },
      {
        gender: "Male",
        name: "Venu",
        city: "Amarica",
        car: "Swift",
        items: null
      },
      {
        gender: "Female",
        name: "Sandra",
        city: "Las Vegas",
        car: "Audi A4",
        items: null
      },
      {
        gender: "Male",
        name: "Venu",
        city: "Amarica",
        car: "Swift",
        items: null
      },
      {
        gender: "Female",
        name: "Sandra",
        city: "Las Vegas",
        car: "Audi A4",
        items: null
      },
      {
        gender: "Male",
        name: "Venu",
        city: "Amarica",
        car: "Swift",
        items: null
      },
      {
        gender: "Female",
        name: "Sandra",
        city: "Las Vegas",
        car: "Audi A4",
        items: null
      },
      {
        gender: "Male",
        name: "Venu",
        city: "Amarica",
        car: "Swift",
        items: null
      },
      {
        gender: "Female",
        name: "Sandra",
        city: "Las Vegas",
        car: "Audi A4",
        items: null
      },
      {
        gender: "Male",
        name: "Venu",
        city: "Amarica",
        car: "Swift",
        items: null
      }
    ];

    let columns2 = [
      { name: "agentName", title: "AgentName" },
      { name: "agency", title: "Agency" },
      { name: "ulb", title: "Ulb" },
      { name: "buildings", title: "Buildings" },
      { name: "dwellings", title: "Dwellings" }
    ];

    let getHiddenColumnsFilteringExtensions = hiddenColumnNames =>
      hiddenColumnNames.map(columnName => ({
        columnName,
        predicate: () => false
      }));
    let defaultHiddenColumnNames = [];
    let filteringColumnExtensions = getHiddenColumnsFilteringExtensions(
      defaultHiddenColumnNames
    );
    let setFilteringColumnExtensions = getHiddenColumnsFilteringExtensions(
      defaultHiddenColumnNames
    );
    let onHiddenColumnNamesChange = hiddenColumnNames =>
      getHiddenColumnsFilteringExtensions(hiddenColumnNames);

    return (
      <div>
        <div className="container-fluid">
          <div className="card">
            {this.state.showdownloadAgentSummeryData ? (
              <div className="agentsummery-downloadoptions">
                <div class="list-group">
                  {/* <CSVLink 
                data={this.state.agentSummeryAllCsv}
                 headers={this.state.agentSummeryHeader}
               
                 >
                  <a  class="list-group-item list-group-item-action">Export all data as csv</a>
                  </CSVLink>
                 <CSVLink data={this.state.agentSummeryData} headers={this.state.agentSummeryHeader}>
                  <a  class="list-group-item list-group-item-action" onClick={this.clickAgentSummeryVisiblecsv.bind(this)}>Export visible data as csv</a>
                  </CSVLink> */}
                  <CSVLink
                    data={this.state.allAgencyDataObject}
                    headers={this.state.headers}
                    filename="dashboard_zipprs.csv"
                  >
                    <a
                      class="list-group-item list-group-item-action"
                      onClick={this.toggleDownloadDropdown}
                    >
                      Export all data as csv
                    </a>
                  </CSVLink>

                  <CSVLink
                    data={this.state.agencyDataObject}
                    headers={this.state.headers}
                    filename="dashboard_zipprs.csv"
                  >
                    <a
                      class="list-group-item list-group-item-action"
                      onClick={this.toggleDownloadDropdown}
                    >
                      Export visible data as csv
                    </a>
                  </CSVLink>
                </div>
              </div>
            ) : (
              ""
            )}

            <div className="col-md-12" id="heading-timeline">
              TIMELINE
            </div>
            <br />
            <div className="row" id="select-row">
              <div className="col-md-3 firsr-select">
                <select
                  class="form-control"
                  id="sel1"
                  onChange={this.agencyFilter.bind(this)}
                >
                  <option value="all">All Agencies</option>
                  {this.state.WorkOrderClients
                    ? this.state.WorkOrderClients.map(client => {
                        return <option value={client.id}>{client.name}</option>;
                      })
                    : ""}
                </select>
              </div>
              <div className="col-md-3">
                <select
                  class="form-control"
                  id="sel1"
                  onChange={this.ulbFilter.bind(this)}
                >
                  <option value="all">All Ulbs</option>
                  {this.state.ulbNameArray
                    ? this.state.ulbNameArray.map(ulb => {
                        return (
                          <option value={ulb.spaceValue}>{ulb.name}</option>
                        );
                      })
                    : ""}
                </select>
              </div>
              <div className="col-md-3">
                <select
                  class="form-control"
                  id="sel1"
                  onChange={this.timeFilter.bind(this)}
                >
                  <option value="lifetime">Life Time</option>
                  <option value="today">Today</option>
                  <option value="yesterday">Yesterday</option>
                  <option value="last_7">Last 7Days</option>
                  <option value="last_14">last 14Days</option>
                  <option value="this_month">This Month</option>
                  <option value="last_month">Last Month</option>
                  <option value="this_year">This Year</option>
                </select>
              </div>
              <div className="col-md-3 last-part">
                <button
                  className="download-button"
                  onClick={this.downloadAgentSummeryData.bind(this)}
                >
                  <svg
                    className="bi bi-arrow-down-short"
                    width="1em"
                    height="1em"
                    viewBox="0 0 16 16"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M4.646 7.646a.5.5 0 01.708 0L8 10.293l2.646-2.647a.5.5 0 01.708.708l-3 3a.5.5 0 01-.708 0l-3-3a.5.5 0 010-.708z"
                      clip-rule="evenodd"
                    />
                    <path
                      fill-rule="evenodd"
                      d="M8 4.5a.5.5 0 01.5.5v5a.5.5 0 01-1 0V5a.5.5 0 01.5-.5z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </button>
              </div>
            </div>
            {this.state.loading ? (
              <>
                {this.state.notGettingData ? (
                  <p>{this.state.notGettingData}</p>
                ) : (
                  <img className="loader" src={loader} />
                )}
              </>
            ) : (
              <Grid rows={this.state.agencyDataObject} columns={columns2}>
                <FilteringState defaultFilters={[]} />
                <IntegratedFiltering />

                <SortingState
                  defaultSorting={[{ columnName: "city", direction: "asc" }]}
                />
                <IntegratedSorting />

                {/* <SearchState defaultValue="" />
        <IntegratedFiltering
          columnExtensions={filteringColumnExtensions}
        /> */}
                <VirtualTable height="30em" />
                <TableHeaderRow showSortingControls />
                <TableFilterRow />
                <TableColumnVisibility
                  defaultHiddenColumnNames={defaultHiddenColumnNames}
                  onHiddenColumnNamesChange={onHiddenColumnNamesChange}
                />
                <Toolbar />
                {/* <SearchPanel /> */}
                <ColumnChooser />
              </Grid>
            )}
          </div>
        </div>
      </div>
    );
  }
}
